<h1 *ngIf="!isAppMobile" class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
  {{ 'caad.modifier-coordonnees.sousTitre' | translate }}
</h1>
<h2 id="titreModification" tabindex="-1">{{ 'caad.modifier-coordonnees.titre' | translate }}</h2>
<dsd-form [formGroup]="formBancaire" (dsdFormSubmit)="naviguerVersPageValidation()">
  <p class="dsd-fw-bold dsd-b-40 dsd-mb-md">{{ 'caad.modifier.coordonnees.ajoutedechamps' | translate }}</p>
  <dsd-container>
    <h3 class="dsd-t-4">{{ 'caad.modifier-coordonnees.adresse.titre' | translate }}</h3>
    <app-modification-adresse
      [formGroup]="formBancaire"
      [isBancaire]="true"
      [adresseCourante]="adresseCourante"
      [adressePostDatee]="adressePostDatee">
    </app-modification-adresse>
    <h3 class="dsd-t-4">{{ 'caad.modifier-coordonnees.courriel.titre' | translate }}</h3>
    <app-modification-courriel
      [formGroup]="formBancaire"
      [required]="false"
      [maxLength]="64"></app-modification-courriel>

    <dsd-fieldset variant="title">
      <h3 class="dsd-t-4" slot="legend">
        {{ 'caad.modifier-coordonnees.telephones.titrePrincipal' | translate }}
      </h3>
      <app-modification-telephone-bancaire
        name="telephonePrincipal"
        [formGroup]="formBancaire.get('telephonePrincipal')"></app-modification-telephone-bancaire>
    </dsd-fieldset>

    <dsd-button
      id="boutonAjoutTelephoneSecondaire"
      tabindex="-1"
      variant="compact"
      class="dsd-mt-md"
      (dsdButtonClick)="clickAjouterTelephoneSecondaire()"
      *ngIf="!formBancaire.get('telephoneSecondaire')">
      {{ 'caad.modifier-coordonnees.telephones.boutons.ajouterSecondaire' | translate }}
    </dsd-button>
    <div *ngIf="formBancaire.get('telephoneSecondaire')" class="dsd-mt-md">
      <dsd-fieldset variant="title">
        <h3 class="dsd-t-4" slot="legend">
          {{ 'caad.modifier-coordonnees.telephones.titreSecondaire' | translate }}
        </h3>
        <app-modification-telephone-bancaire
          name="telephoneSecondaire"
          [formGroup]="formBancaire.get('telephoneSecondaire')"></app-modification-telephone-bancaire>
      </dsd-fieldset>
      <dsd-button variant="compact" theme="red" (dsdButtonClick)="supprimerTelephoneSecondaire()" class="dsd-mt-md">
        {{ 'caad.modifier-coordonnees.telephones.boutons.supprimer' | translate }}
        <span class="dsd-sr-only"
          >&nbsp; {{ 'caad.modifier-coordonnees.telephones.horsEcran.telephoneSecondaire' | translate }}</span
        >
      </dsd-button>
    </div>

    <div class="dsd-mt-md">
      <dsd-button
        id="boutonAjoutTelephoneTravail"
        tabindex="-1"
        variant="compact"
        (dsdButtonClick)="clickAjouterTelephoneTravail()"
        *ngIf="!formBancaire.get('telephoneTravail')">
        {{ 'caad.modifier-coordonnees.telephones.boutons.ajouterTravail' | translate }}
      </dsd-button>
      <div *ngIf="formBancaire.get('telephoneTravail')">
        <dsd-fieldset variant="title">
          <h3 class="dsd-t-4" slot="legend">
            {{ 'caad.modifier-coordonnees.telephones.titreTravail' | translate }}
          </h3>
          <app-modification-telephone-bancaire
            name="telephoneTravail"
            variantTravail="true"
            [formGroup]="formBancaire.get('telephoneTravail')"></app-modification-telephone-bancaire>
        </dsd-fieldset>
        <dsd-button variant="compact" theme="red" (dsdButtonClick)="supprimerTelephoneTravail()" class="dsd-mt-md">
          {{ 'caad.modifier-coordonnees.telephones.boutons.supprimer' | translate }}
          <span class="dsd-sr-only"
            >&nbsp; {{ 'caad.modifier-coordonnees.telephones.horsEcran.telephoneTravail' | translate }}</span
          >
        </dsd-button>
      </div>
    </div>
  </dsd-container>
  <div class="zone-btn">
    <dsd-button variant="primary" full-width="xs" type="submit" (dsdButtonClick)="valider()"
      >{{ 'caad.button.valider' | translate }}
    </dsd-button>
    <dsd-button full-width="xs" id="brtAnnuler" (dsdButtonClick)="annulerModification()">{{
      'caad.button.annuler' | translate
    }}</dsd-button>
  </div>
</dsd-form>

<app-modale-supprimer
  variant="telephone"
  [show]="showModaleSupprimerTelephone"
  (suppressionConfirmee)="handleConfirmSuppressionTelephone()"
  (suppressionAnnulee)="closeModal()">
</app-modale-supprimer>
